module.exports = __webpack_public_path__ + "static/img/img5.95c76b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/img5.png
// module id = lMnf
// module chunks = 1